import Raven from 'raven-js';

/* @ngInject */
export default function ($urlRouterProvider, $locationProvider, $authProvider, RestangularProvider, $qProvider, $httpProvider, $provide) {
	RestangularProvider.setBaseUrl(process.env.API_ENDPOINT);

	RestangularProvider.setErrorInterceptor((response, deferred, responseHandler) => {
		Raven.captureException(new Error(response.data.message), {
			extra: response.data,
		});

		return true;
	});

	$authProvider.loginUrl = `${process.env.API_ENDPOINT}auth/authenticate`;

	$urlRouterProvider.otherwise('/splash');

	$locationProvider.html5Mode(true);

	$qProvider.errorOnUnhandledRejections(false);

	$provide.factory('httpInterceptor', ($q) => {
		return {
			'requestError': (error) => {
				Raven.captureException(new Error(error.data.message), {
					extra: error.data,
				});

				return $q.reject(error);
			},

			'responseError': (error) => {
				Raven.captureException(new Error(error.data.message), {
					extra: error.data,
				});

				return $q.reject(error);
			},
		};
	});

	$httpProvider.interceptors.push('httpInterceptor');
};


// WEBPACK FOOTER //
// ./src/js/config.js